import React, { forwardRef } from 'react';
import styled from 'styled-components';
import { IndicatorBase } from '../IndicatorBase/IndicatorBase.js';
import { LoaderStyle } from './Loader.styles.js';

const _Loader = forwardRef((props, ref) => {
    const { color, delay, // Used only in LoaderStyle, prevent passing it to DOM
    reducedMotion, // Used only in LoaderStyle, prevent passing it to DOM
    style, ...rest } = props;
    return React.createElement(IndicatorBase, { style: { color, ...style }, ...rest, ref: ref });
});
_Loader.displayName = '_Loader';
const defaultProps = {
    delay: true,
    reducedMotion: false,
    size: 'small',
};
const Loader = styled(_Loader) `
    ${LoaderStyle}
`;
Loader.defaultProps = defaultProps;

export { Loader };
//# sourceMappingURL=Loader.js.map
